module.exports = __webpack_public_path__ + "media/images/sp/banner/hokepon-a1fd56c156bee8b91f40f997365b2e40.png";